import apiClient from '../apiClient';
import { GET_BALANCE_HISTORY_BY_COMPANY_CODE } from '../apiUrl';

const getBalanceHistoryByCompanyCodeApi = Id => {
  return apiClient.get(GET_BALANCE_HISTORY_BY_COMPANY_CODE(Id));
};

export default getBalanceHistoryByCompanyCodeApi;
